// extracted by mini-css-extract-plugin
export default {"root":"_tQFw","container":"_S5gi"};